import { html } from 'lit';
import { navigate } from '../../router.js';

/**
 * The trail at the top of a page's content, above whatever the page is about.
 *
 * `lia-breadcrumb` renders a `NavItem[]` and raises a cancelable `lia-navigate` for each link, which is
 * what the router wants: the click is routed rather than reloaded. It is the first thing in the content
 * column, in the same gutter as the card below it, rather than part of the heading band - the heading
 * says what the page is, the trail says where it is, and the page's content is where a reader looks for
 * the way back.
 *
 * Every page of both applications has one, top-level pages included, so nobody has to work out where
 * they are from the address bar - and so the shape never changes from page to page. The home crumb is
 * each application's own front: `/` for a developer, `/admin` for an operator.
 */
export function breadcrumb(items, { home = '/' } = {})
{
   return html`
      <lia-breadcrumb
         class="covdbg-trail"
         .items=${items}
         home-href=${home}
         home-label="Home"
         @lia-navigate=${event =>
         {
            const url = event.detail?.url;

            if (url && url.startsWith('/'))
            {
               event.preventDefault();
               navigate(url);
            }
         }}
      ></lia-breadcrumb>`;
}
